import { render, staticRenderFns } from "./BookTravel.vue?vue&type=template&id=40ad667f&scoped=true&"
import script from "./BookTravel.vue?vue&type=script&lang=js&"
export * from "./BookTravel.vue?vue&type=script&lang=js&"
import style0 from "./BookTravel.vue?vue&type=style&index=0&id=40ad667f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad667f",
  null
  
)

export default component.exports